import { Grid } from '@mui/material';
import FieldText from '../../../components/general/fields/fieldText';
import { OrbitSectionHeader } from '../components/orbitSectionHeader';
import { OrbitCallInfoProps } from '../sectionProps';
import { useOrbitCallInfo } from './hook';

export const OrbitCallInfo = (props: OrbitCallInfoProps) => {
    const { readOnly, callIdReadOnly } = props;
    const { formik } = useOrbitCallInfo(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <OrbitSectionHeader title="Información de la llamada" />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Call ID"
                    name="callId"
                    size="small"
                    disabled={readOnly || callIdReadOnly}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.callId}
                    errors={formik.errors.callId}
                    value={formik.values.callId}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
